// Rompe-cache de las imagenes de /public.
//
// El JS y el CSS ya vienen versionados: CRA les mete un hash en el nombre
// (main.21a2b8bc.js), asi que al cambiar el contenido cambia la URL y el
// navegador se ve obligado a bajarlos otra vez. Las imagenes no: se suben por
// FTP con el mismo nombre de siempre, y quien ya visito el sitio se queda con
// la copia vieja hasta que expire la cache. Paso justo eso con cdmx.jpg y
// guadalajara.jpg, que en el servidor siguieron en 300x300.
//
// Sube ASSET_VERSION en el deploy en el que reemplaces alguna imagen. Al
// cambiar el numero cambian todas las URLs, asi que los navegadores vuelven a
// pedir las fotos una vez; por eso se sube solo cuando hace falta y no en cada
// build.
//
// Los favicons y el og.jpg quedan fuera a proposito: los cachea Facebook,
// WhatsApp y el propio navegador de formas que el parametro no arregla, y una
// URL con query en la tarjeta de Open Graph puede hacer que el scraper la trate
// como una imagen distinta cada vez.
export const ASSET_VERSION = '2';

const asset = (path) => `${path}?v=${ASSET_VERSION}`;

export default asset;
